import { render, staticRenderFns } from "./commonProblems.vue?vue&type=template&id=3c507c2b&scoped=true&"
import script from "./commonProblems.vue?vue&type=script&lang=js&"
export * from "./commonProblems.vue?vue&type=script&lang=js&"
import style0 from "./commonProblems.vue?vue&type=style&index=0&id=3c507c2b&lang=less&scoped=true&"
import style1 from "./commonProblems.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c507c2b",
  null
  
)

export default component.exports